import {
  // SIGN IN TYPE
  SIGN_IN_REQUEST,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILURE,
  SIGN_UP_REQUEST,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  COMPANY_USER_CREATE_REQUEST,
  COMPANY_USER_CREATE_SUCCESS,
  COMPANY_USER_CREATE_FAILURE,
  COMPANY_USER_UPDATE_REQUEST,
  COMPANY_USER_UPDATE_SUCCESS,
  COMPANY_USER_UPDATE_FAILURE,
  COMPANY_USER_DELETE_REQUEST,
  COMPANY_USER_DELETE_SUCCESS,
  COMPANY_USER_DELETE_FAILURE,
  COMPANY_USER_LIST_REQUEST,
  COMPANY_USER_LIST_SUCCESS,
  COMPANY_USER_LIST_FAILURE,
  GET_Company_LIST_REQUEST,
  GET_Company_LIST_SUCCESS,
  GET_Comapny_LIST_FAILURE,
  GET_Company_Alter_REQUEST,
  GET_Company_Alter_SUCCESS,
  GET_Comapny_Alter_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  // Group Action Type
  GROUP_LIST_REQUEST,
  GROUP_LIST_SUCCESS,
  GROUP_LIST_FAILURE,
  GROUP_CREATE_REQUEST,
  GROUP_CREATE_SUCCESS,
  GROUP_CREATE_FAILURE,
  GROUP_UPDATE_REQUEST,
  GROUP_UPDATE_SUCCESS,
  GROUP_UPDATE_FAILURE,
  GROUP_DELETE_REQUEST,
  GROUP_DELETE_SUCCESS,
  GROUP_DELETE_FAILURE,
  GROUP_SINGLE_REQUEST,
  GROUP_SINGLE_SUCCESS,
  GROUP_SINGLE_FAILURE,
  GROUP_LIST_UNDER_REQUEST,
  GROUP_LIST_UNDER_SUCCESS,
  GROUP_LIST_UNDER_FAILURE,
  // Ledger Action Type
  LEDGER_CREATE_REQUEST,
  LEDGER_CREATE_SUCCESS,
  LEDGER_CREATE_FAILURE,
  LEDGER_SINGLE_DATA_REQUEST,
  LEDGER_SINGLE_DATA_SUCCESS,
  LEDGER_SINGLE_DATA_FAILURE,
  LEDGER_UPDATE_REQUEST,
  LEDGER_UPDATE_SUCCESS,
  LEDGER_UPDATE_FAILURE,
  LEDGER_DELETE_REQUEST,
  LEDGER_DELETE_SUCCESS,
  LEDGER_DELETE_FAILURE,
  LEDGER_COMMON_LIST_REQUEST,
  LEDGER_COMMON_LIST_SUCCESS,
  LEDGER_COMMON_LIST_FAILURE,
  LEDGER_LIST_REQUEST,
  LEDGER_LIST_SUCCESS,
  LEDGER_LIST_FAILURE,
  // UNIT Action Type
  UNIT_CREATE_REQUEST,
  UNIT_CREATE_SUCCESS,
  UNIT_CREATE_FAILURE,
  UNIT_LIST_REQUEST,
  UNIT_LIST_SUCCESS,
  UNIT_LIST_FAILURE,
  UNIT_DELETE_REQUEST,
  UNIT_DELETE_SUCCESS,
  UNIT_DELETE_FAILURE,
  UNIT_UPDATE_REQUEST,
  UNIT_UPDATE_SUCCESS,
  UNIT_UPDATE_FAILURE,
  UNIT_SINGLE_DATA_REQUEST,
  UNIT_SINGLE_DATA_SUCCESS,
  UNIT_SINGLE_DATA_FAILURE,
  // UQC CODE Action Type
  UQC_CODE_LIST_REQUEST,
  UQC_CODE_LIST_SUCCESS,
  UQC_CODE_LIST_FAILURE,
  UQC_CODE_CREATE_REQUEST,
  UQC_CODE_CREATE_SUCCESS,
  UQC_CODE_CREATE_FAILURE,
  UQC_CODE_DELETE_REQUEST,
  UQC_CODE_DELETE_SUCCESS,
  UQC_CODE_DELETE_FAILURE,
  UQC_CODE_UPDATE_REQUEST,
  UQC_CODE_UPDATE_SUCCESS,
  UQC_CODE_UPDATE_FAILURE,
  UQC_CODE_SINGLE_DATA_REQUEST,
  UQC_CODE_SINGLE_DATA_SUCCESS,
  UQC_CODE_SINGLE_DATA_FAILURE,
  // STOCK CATEGORY Action Type
  STOCK_CATEGORY_CREATE_REQUEST,
  STOCK_CATEGORY_CREATE_SUCCESS,
  STOCK_CATEGORY_CREATE_FAILURE,
  STOCK_CATEGORY_NAME_VALIDATE_REQUEST,
  STOCK_CATEGORY_NAME_VALIDATE_SUCCESS,
  STOCK_CATEGORY_NAME_VALIDATE_FAILURE,
  STOCK_CATEGORY_UPDATE_REQUEST,
  STOCK_CATEGORY_UPDATE_SUCCESS,
  STOCK_CATEGORY_UPDATE_FAILURE,
  STOCK_CATEGORY_LIST_REQUEST,
  STOCK_CATEGORY_LIST_SUCCESS,
  STOCK_CATEGORY_LIST_FAILURE,
  STOCK_CATEGORY_UNDER_LIST_REQUEST,
  STOCK_CATEGORY_UNDER_LIST_SUCCESS,
  STOCK_CATEGORY_UNDER_LIST_FAILURE,
  STOCK_CATEGORY_DELETE_REQUEST,
  STOCK_CATEGORY_DELETE_SUCCESS,
  STOCK_CATEGORY_DELETE_FAILURE,
  STOCK_CATEGORY_SINGLE_REQUEST,
  STOCK_CATEGORY_SINGLE_SUCCESS,
  STOCK_CATEGORY_SINGLE_FAILURE,
  // STOCK GROUP Action Type
  STOCK_GROUP_CREATE_REQUEST,
  STOCK_GROUP_CREATE_SUCCESS,
  STOCK_GROUP_CREATE_FAILURE,
  STOCK_GROUP_UPDATE_REQUEST,
  STOCK_GROUP_UPDATE_SUCCESS,
  STOCK_GROUP_UPDATE_FAILURE,
  STOCK_GROUP_LIST_REQUEST,
  STOCK_GROUP_LIST_SUCCESS,
  STOCK_GROUP_LIST_FAILURE,
  STOCK_GROUP_UNDER_LIST_REQUEST,
  STOCK_GROUP_UNDER_LIST_SUCCESS,
  STOCK_GROUP_UNDER_LIST_FAILURE,
  STOCK_GROUP_DELETE_REQUEST,
  STOCK_GROUP_DELETE_SUCCESS,
  STOCK_GROUP_DELETE_FAILURE,
  STOCK_GROUP_SINGLE_DATA_REQUEST,
  STOCK_GROUP_SINGLE_DATA_SUCCESS,
  STOCK_GROUP_SINGLE_DATA_FAILURE,
  // STOCK COMPANY Action Type
  STOCK_COMPANY_CREATE_REQUEST,
  STOCK_COMPANY_CREATE_SUCCESS,
  STOCK_COMPANY_CREATE_FAILURE,
  STOCK_COMPANY_UPDATE_REQUEST,
  STOCK_COMPANY_UPDATE_SUCCESS,
  STOCK_COMPANY_UPDATE_FAILURE,
  STOCK_COMPANY_LIST_REQUEST,
  STOCK_COMPANY_LIST_SUCCESS,
  STOCK_COMPANY_LIST_FAILURE,
  STOCK_COMPANY_DELETE_REQUEST,
  STOCK_COMPANY_DELETE_SUCCESS,
  STOCK_COMPANY_DELETE_FAILURE,
  STOCK_COMPANY_SINGLE_DATA_REQUEST,
  STOCK_COMPANY_SINGLE_DATA_SUCCESS,
  STOCK_COMPANY_SINGLE_DATA_FAILURE,
  // STOCK ITEM Action Type
  STOCK_ITEM_CREATE_REQUEST,
  STOCK_ITEM_CREATE_SUCCESS,
  STOCK_ITEM_CREATE_FAILURE,
  STOCK_ITEM_UPDATE_REQUEST,
  STOCK_ITEM_UPDATE_SUCCESS,
  STOCK_ITEM_UPDATE_FAILURE,
  STOCK_ITEM_LIST_REQUEST,
  STOCK_ITEM_LIST_SUCCESS,
  STOCK_ITEM_LIST_FAILURE,
  STOCK_ITEM_DELETE_REQUEST,
  STOCK_ITEM_DELETE_SUCCESS,
  STOCK_ITEM_DELETE_FAILURE,
  STOCK_ITEM_SINGLE_DATA_REQUEST,
  STOCK_ITEM_SINGLE_DATA_SUCCESS,
  STOCK_ITEM_SINGLE_DATA_FAILURE,
  STOCK_ITEM_LIST_TO_DROPDOWN_REQUEST,
  STOCK_ITEM_LIST_TO_DROPDOWN_SUCCESS,
  STOCK_ITEM_LIST_TO_DROPDOWN_FAILURE,
  // VOUCHER TYPE Action Type
  VOUCHER_TYPE_CREATE_REQUEST,
  VOUCHER_TYPE_CREATE_SUCCESS,
  VOUCHER_TYPE_CREATE_FAILURE,
  VOUCHER_TYPE_UPDATE_REQUEST,
  VOUCHER_TYPE_UPDATE_SUCCESS,
  VOUCHER_TYPE_UPDATE_FAILURE,
  VOUCHER_TYPE_LIST_REQUEST,
  VOUCHER_TYPE_LIST_SUCCESS,
  VOUCHER_TYPE_LIST_FAILURE,
  VOUCHER_TYPE_DELETE_REQUEST,
  VOUCHER_TYPE_DELETE_SUCCESS,
  VOUCHER_TYPE_DELETE_FAILURE,
  VOUCHER_TYPE_SINGLE_DATA_REQUEST,
  VOUCHER_TYPE_SINGLE_DATA_SUCCESS,
  VOUCHER_TYPE_SINGLE_DATA_FAILURE,
  VOUCHER_TYPE_DEFAULT_LIST_REQUEST,
  VOUCHER_TYPE_DEFAULT_LIST_SUCCSESS,
  VOUCHER_TYPE_DEFAULT_LIST_FAILURE,
  VOUCHER_TYPE_NAME_CHECK_REQUEST,
  VOUCHER_TYPE_NAME_CHECK_SUCCESS,
  VOUCHER_TYPE_NAME_CHECK_FAILURE,
  // Number Series For Voucher Type Action Type
  NUMBER_SERIES_CREATE_REQUEST,
  NUMBER_SERIES_CREATE_SUCCESS,
  NUMBER_SERIES_CREATE_FAILURE,
  NUMBER_SERIES_LIST_REQUEST,
  NUMBER_SERIES_LIST_SUCCESS,
  NUMBER_SERIES_LIST_FAILURE,
  NUMBER_SERIES_SINGLE_LIST_REQUEST,
  NUMBER_SERIES_SINGLE_LIST_SUCCESS,
  NUMBER_SERIES_SINGLE_LIST_FAILURE,
  NUMBER_SERIES_UPDATE_REQUEST,
  NUMBER_SERIES_UPDATE_SUCCESS,
  NUMBER_SERIES_UPDATE_FAILURE,
  // GODOWN Action Type
  GODOWN_CREATE_REQUEST,
  GODOWN_CREATE_SUCCESS,
  GODOWN_CREATE_FAILURE,
  GODOWN_UPDATE_REQUEST,
  GODOWN_UPDATE_SUCCESS,
  GODOWN_UPDATE_FAILURE,
  GODOWN_LIST_REQUEST,
  GODOWN_LIST_SUCCESS,
  GODOWN_LIST_FAILURE,
  GODOWN_DELETE_REQUEST,
  GODOWN_DELETE_SUCCESS,
  GODOWN_DELETE_FAILURE,
  GODOWN_SINGLE_DATA_REQUEST,
  GODOWN_SINGLE_DATA_SUCCESS,
  GODOWN_SINGLE_DATA_FAILURE,
  GODOWN_PRIMARY_LIST_REQUEST,
  GODOWN_PRIMARY_LIST_SUCCESS,
  GODOWN_PRIMARY_LIST_FAILURE,
  //  VOUCHER ENTRY's Action Type
  CONTRA_LEDGER_LIST_REQUEST,
  CONTRA_LEDGER_LIST_SUCCESS,
  CONTRA_LEDGER_LIST_FAILURE,
  CONTRA_VOUCHER_ENTRY_CREATE_REQUEST,
  CONTRA_VOUCHER_ENTRY_CREATE_SUCCESS,
  CONTRA_VOUCHER_ENTRY_CREATE_FAILURE,
  CONTRA_VOUCHER_ENTRY_LIST_REQUEST,
  CONTRA_VOUCHER_ENTRY_LIST_SUCCESS,
  CONTRA_VOUCHER_ENTRY_LIST_FAILURE,
  CONTRA_VOUCHER_ENTRY_SINGLE_REQUEST,
  CONTRA_VOUCHER_ENTRY_SINGLE_SUCCESS,
  CONTRA_VOUCHER_ENTRY_SINGLE_FAILURE,
  CONTRA_VOUCHER_ENTRY_UPDATE_REQUEST,
  CONTRA_VOUCHER_ENTRY_UPDATE_SUCCESS,
  CONTRA_VOUCHER_ENTRY_UPDATE_FAILURE,
  SERIAL_NUMBER_REQUEST,
  SERIAL_NUMBER_SUCCESS,
  SERIAL_NUMBER_FAILURE,
  VOUCHER_TYPE_SAVE,
  VOUCHER_ENTRY_DELETE_REQUEST,
  VOUCHER_ENTRY_DELETE_SUCCESS,
  VOUCHER_ENTRY_DELETE_FAILURE,
  // lEDGER BOOK LISTING Action Type
  LEDGER_BOOK_REQUEST,
  LEDGER_BOOK_SUCCESS,
  LEDGER_BOOK_FAILURE,
  // LEDGER POSTING LIST Action Type
  LEDGER_POSTING_LIST_REQUEST,
  LEDGER_POSTING_LIST_SUCCESS,
  LEDGER_POSTING_LIST_FAILURE,
  // CURRENT PERIOD Type
  CURRENT_DATE_SAVE,
  CURRENT_PERIOD_SAVE,
  // STOCK SUMMARY LIST -------------
  STOCK_SUMMARY_LIST_REQUEST,
  STOCK_SUMMARY_LIST_SUCCESS,
  STOCK_SUMMARY_LIST_FAILURE,
  STOCK_SUMMARY_GODOWN_FILTER_LIST_REQUEST,
  STOCK_SUMMARY_GODOWN_FILTER_LIST_SUCCESS,
  STOCK_SUMMARY_GODOWN_FILTER_LIST_FAILURE,
  STOCK_SUMMARY_ITEM_VOUCHER_REQUEST,
  STOCK_SUMMARY_ITEM_VOUCHER_SUCCESS,
  STOCK_SUMMARY_ITEM_VOUCHER_FAILURE,

  // Max Date of Entry -------------
  MAX_DATE_OF_ENTRY_REQUEST,
  MAX_DATE_OF_ENTRY_SUCCESS,
  MAX_DATE_OF_ENTRY_FAILURE,
  // Filter Voucher Type
  FILTER_VOUCHER_TYPE_DATA,
  FILTER_API_CALL,
  PROFIT_AND_LOSS_REQUEST,
  PROFIT_AND_LOSS_SUCCESS,
  PROFIT_AND_LOSS_FAILURE,
  GROUP_SUMMARY_REQUEST,
  GROUP_SUMMARY_SUCCESS,
  GROUP_SUMMARY_FAILURE,
  RESET_DATA,
  // Balance Sheet
  BALANCE_SHEET_REQUEST,
  BALANCE_SHEET_SUCCESS,
  BALANCE_SHEET_FAILURE,
  OPEN_MODAL,
  CLOSE_MODAL,
  CLOSE_ALL_MODALS,
  UNIT_LIST_SIMPLE_REQUEST,
  UNIT_LIST_SIMPLE_SUCCESS,
  UNIT_LIST_SIMPLE_FAILURE,
  UPDATE_CURRENT_DATE_AUTO,
  SAVE_PAGE_HISTORY,
  SET_PAGE_FOCUS,
  SAVE_STOCK_SUMMARY_STATE,
  SAVE_CHART_OF_ACCOUNTS_STATE,
  SAVE_DAYBOOK_STATE,
  BRANCH_CREATE_REQUEST, BRANCH_CREATE_SUCCESS, BRANCH_CREATE_FAILURE,
  BRANCH_LIST_REQUEST, BRANCH_LIST_SUCCESS, BRANCH_LIST_FAILURE,
  BRANCH_DELETE_REQUEST, BRANCH_DELETE_SUCCESS, BRANCH_DELETE_FAILURE,
  BRANCH_LOGIN_REQUEST, BRANCH_LOGIN_SUCCESS, BRANCH_LOGIN_FAILURE,
} from "./action-types";
import axiosInstance from "../../axios/axiosinstance";
// import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { restoreAltCFocusReturn } from "../../utils/altCFocusReturn";

/**
 * Production-grade Redux thunk helper
 * Handles async actions with proper error handling, toast notifications, and FormData support
 *
 * @param {Object} config - Configuration object
 * @param {string} config.endpoint - API endpoint (e.g., 'login', 'create-stock-item')
 * @param {string} config.method - HTTP method ('get', 'post', 'put', 'delete', 'patch')
 * @param {*} config.data - Request payload (can be FormData, object, etc.)
 * @param {string} config.requestType - Redux action type for REQUEST
 * @param {string} config.successType - Redux action type for SUCCESS
 * @param {string} config.failureType - Redux action type for FAILURE
 * @param {string} config.successMessage - Optional success toast message
 * @param {boolean} config.silent - If true, don't show success toast (default: false)
 * @returns {Function} Redux thunk function
 */
const createAsyncThunk = ({
  endpoint,
  method = "post",
  data = null,
  requestType,
  successType,
  failureType,
  successMessage = null,
  silent = false,
}) => {
  return async (dispatch) => {
    dispatch({ type: requestType });
    try {
      const config = {};
      let response;
      const axiosMethod = axiosInstance[method.toLowerCase()];

      if (!axiosMethod) {
        throw new Error(`Invalid HTTP method: ${method}`);
      }

      if (method.toLowerCase() === "get" || method.toLowerCase() === "delete") {
        response = await axiosMethod(endpoint, { params: data });
      } else {
        response = await axiosMethod(endpoint, data, config);
      }

      const responseData = response.data;

      if (responseData?.status) {
        dispatch({ type: successType, payload: responseData });

        if (!silent && successMessage) {
          toast.success(successMessage, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        } else if (!silent && responseData?.message) {
          toast.success(responseData.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }

        return responseData;
      } else {
        dispatch({ type: failureType, payload: responseData });

        const error = new Error(responseData?.message || "Operation failed");
        error.responseData = responseData;
        throw error;
      }
    } catch (error) {
      const errorPayload = error.response?.data || error.responseData || error;
      dispatch({ type: failureType, payload: errorPayload });

      throw error;
    }
  };
};

// for user signIn
export function signIn(data) {
  return async (dispatch) => {
    dispatch({ type: SIGN_IN_REQUEST });
    try {
      var response = await axiosInstance.post(`login`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: SIGN_IN_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: SIGN_IN_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: SIGN_IN_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// for user signUp
export function signUp(data) {
  return async (dispatch) => {
    dispatch({ type: SIGN_UP_REQUEST });
    try {
      var response = await axiosInstance.post(`company_registration`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: SIGN_UP_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: SIGN_UP_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: SIGN_UP_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// for company user create
export function companyUserCreate(data) {
  return async (dispatch) => {
    dispatch({ type: COMPANY_USER_CREATE_REQUEST });
    try {
      var response = await axiosInstance.post(`company_user_create`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: COMPANY_USER_CREATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: COMPANY_USER_CREATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: COMPANY_USER_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// for company user update
export function companyUserUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: COMPANY_USER_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`company_user_update`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: COMPANY_USER_UPDATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: COMPANY_USER_UPDATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: COMPANY_USER_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// for company user delete
export function companyUserDelete(data) {
  return async (dispatch) => {
    dispatch({ type: COMPANY_USER_DELETE_REQUEST });
    try {
      var response = await axiosInstance.post(`company_user_delete`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: COMPANY_USER_DELETE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: COMPANY_USER_DELETE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: COMPANY_USER_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// for company user list
export function companyUserList(data, config = {}) {
  return async (dispatch) => {
    dispatch({ type: COMPANY_USER_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(
        `company_users_list`,
        data,
        config,
      );
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: COMPANY_USER_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: COMPANY_USER_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: COMPANY_USER_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// logout
export function logOut() {
  return async (dispatch) => {
    dispatch({ type: LOGOUT_REQUEST, payload: "Logout_Request" });
    try {
      dispatch({ type: LOGOUT_SUCCESS, payload: "Logout_Success" });
      dispatch({ type: RESET_DATA });
    } catch (e) {
      dispatch({ type: LOGOUT_FAILURE, payload: "Logout_Failure" });
    }
  };
}
// for Get Company Alter
export function getCompanyAlter(data) {
  return async (dispatch) => {
    dispatch({ type: GET_Company_Alter_REQUEST });
    try {
      var response = await axiosInstance.post(`updateduserprofile`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        const getFormDataValue = (formData, key) => {
          if (!formData || typeof formData.get !== "function") return undefined;
          const value = formData.get(key);
          return value === null ? undefined : value;
        };

        const fallbackData = {
          company_id: getFormDataValue(data, "id"),
          customer_code: getFormDataValue(data, "customer_code"),
          user_name: getFormDataValue(data, "user_name"),
          company_name: getFormDataValue(data, "company_name"),
          mailing_name: getFormDataValue(data, "mailing_name"),
          address: getFormDataValue(data, "address"),
          city: getFormDataValue(data, "city"),
          state: getFormDataValue(data, "state"),
          country: getFormDataValue(data, "country"),
          pincode: getFormDataValue(data, "pincode"),
          mobile: getFormDataValue(data, "mobile"),
          telephone: getFormDataValue(data, "telephone"),
          fax: getFormDataValue(data, "fax"),
          email: getFormDataValue(data, "email"),
          website: getFormDataValue(data, "website"),
          formal_name: getFormDataValue(data, "formal_name"),
          suffex_symbol_amount: getFormDataValue(data, "suffex_symbol_amount"),
          base_currancy_symbol: getFormDataValue(data, "base_currancy_symbol"),
          add_space_between_amount_symbol: getFormDataValue(
            data,
            "add_space_between_amount_symbol",
          ),
          financial_year_begning_form: getFormDataValue(
            data,
            "financial_year_begning_form",
          ),
          books_being_date: getFormDataValue(data, "books_being_date"),
          enable_tally_audit_feature: getFormDataValue(
            data,
            "enable_tally_audit_feature",
          ),
          no_of_decimal_place: getFormDataValue(data, "no_of_decimal_place"),
          word_reprenting_after_amount: getFormDataValue(
            data,
            "word_reprenting_after_amount",
          ),
          no_of_decimal_place_for_amount: getFormDataValue(
            data,
            "no_of_decimal_place_for_amount",
          ),
        };

        dispatch({
          type: GET_Company_Alter_SUCCESS,
          payload: {
            ...responseJson,
            data: responseJson?.data || fallbackData,
          },
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GET_Comapny_Alter_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GET_Comapny_Alter_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// for Get Company List
export const getCompanyList = () =>
  createAsyncThunk({
    endpoint: "company-list",
    method: "get",
    data: null,
    requestType: GET_Company_LIST_REQUEST,
    successType: GET_Company_LIST_SUCCESS,
    failureType: GET_Comapny_LIST_FAILURE,
    silent: true, // Don't show toast for list operations
  });
// FOR GROUP LIST
export function groupList(data) {
  return async (dispatch) => {
    dispatch({ type: GROUP_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`group-list`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: GROUP_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GROUP_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GROUP_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function groupListCreate(data) {
  return async (dispatch) => {
    dispatch({ type: GROUP_LIST_UNDER_REQUEST });
    try {
      var response = await axiosInstance.post(`all-group-list`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: GROUP_LIST_UNDER_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GROUP_LIST_UNDER_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GROUP_LIST_UNDER_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function groupCreate(data) {
  return async (dispatch) => {
    dispatch({ type: GROUP_CREATE_REQUEST });
    try {
      var response = await axiosInstance.post(`create_group`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: GROUP_CREATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GROUP_CREATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GROUP_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function groupUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: GROUP_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`update_group`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: GROUP_UPDATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GROUP_UPDATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GROUP_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function groupDelete(data) {
  return async (dispatch) => {
    dispatch({ type: GROUP_DELETE_REQUEST });
    try {
      var response = await axiosInstance.post(`delete_group`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: GROUP_DELETE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GROUP_DELETE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GROUP_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function groupSingle(id) {
  return async (dispatch) => {
    dispatch({ type: GROUP_SINGLE_REQUEST });
    try {
      var response = await axiosInstance.get(`single_group/${id}`);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: GROUP_SINGLE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GROUP_SINGLE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GROUP_SINGLE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}

// for ledger create ==================================================================================================================================================
export function ledgerCreate(data) {
  return async (dispatch) => {
    dispatch({ type: LEDGER_CREATE_REQUEST });
    try {
      //console.log(data); return;
      var response = await axiosInstance.post(`ledger_creation`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: LEDGER_CREATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: LEDGER_CREATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: LEDGER_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}

// for ledger create ==================================================================================================================================================
export function ledgerSingleData(data) {
  return async (dispatch) => {
    dispatch({ type: LEDGER_SINGLE_DATA_REQUEST });
    try {
      var response = await axiosInstance.post(`singleLedger`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: LEDGER_SINGLE_DATA_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: LEDGER_SINGLE_DATA_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: LEDGER_SINGLE_DATA_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function ledgerUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: LEDGER_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`update_ledger`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: LEDGER_UPDATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: LEDGER_UPDATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: LEDGER_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function ledgerDelete(data) {
  return async (dispatch) => {
    dispatch({ type: LEDGER_DELETE_REQUEST });
    try {
      var response = await axiosInstance.post(`delete_ledger`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: LEDGER_DELETE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: LEDGER_DELETE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: LEDGER_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function ledgerCommonList(data) {
  return async (dispatch) => {
    dispatch({ type: LEDGER_COMMON_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`common-ledger-List`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: LEDGER_COMMON_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: LEDGER_COMMON_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: LEDGER_COMMON_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function ledgerList(data) {
  return async (dispatch) => {
    dispatch({ type: LEDGER_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`ledgerList`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: LEDGER_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: LEDGER_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: LEDGER_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function unitsCreate(data) {
  return async (dispatch) => {
    dispatch({ type: UNIT_CREATE_REQUEST });
    try {
      var response = await axiosInstance.post(`unit_create`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: UNIT_CREATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: UNIT_CREATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: UNIT_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function unitsListing(data) {
  return async (dispatch) => {
    dispatch({ type: UNIT_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`unit_List`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: UNIT_LIST_SUCCESS, payload: responseJson });
        //return Promise.resolve(responseJson);
      } else {
        dispatch({ type: UNIT_LIST_FAILURE, payload: responseJson });
        //return Promise.reject(responseJson);
      }
      return Promise.resolve(responseJson);
    } catch (error) {
      console.log("error odf unit", error);
      dispatch({ type: UNIT_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function unitsListingSimple(data) {
  return async (dispatch) => {
    dispatch({ type: UNIT_LIST_SIMPLE_REQUEST });
    try {
      var response = await axiosInstance.post(`simple_unit_List`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: UNIT_LIST_SIMPLE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: UNIT_LIST_SIMPLE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      console.log("error odf unit", error);
      dispatch({ type: UNIT_LIST_SIMPLE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function unitsUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: UNIT_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`update_unit`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: UNIT_UPDATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: UNIT_UPDATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: UNIT_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function unitsDelete(data) {
  return async (dispatch) => {
    dispatch({ type: UNIT_DELETE_REQUEST });
    try {
      var response = await axiosInstance.post(`delete_units`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: UNIT_DELETE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: UNIT_DELETE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: UNIT_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function unitsSingleData(data) {
  return async (dispatch) => {
    dispatch({ type: UNIT_SINGLE_DATA_REQUEST });
    try {
      var response = await axiosInstance.post(`single_unit_record`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: UNIT_SINGLE_DATA_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: UNIT_SINGLE_DATA_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: UNIT_SINGLE_DATA_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function uqcListing(data) {
  return async (dispatch) => {
    dispatch({ type: UQC_CODE_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`uqc_List`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: UQC_CODE_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: UQC_CODE_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: UQC_CODE_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function uqcCreate(data) {
  return async (dispatch) => {
    dispatch({ type: UQC_CODE_CREATE_REQUEST });
    try {
      var response = await axiosInstance.post(`uqc_create`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        console.log(responseJson);
        dispatch({ type: UQC_CODE_CREATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: UQC_CODE_CREATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: UQC_CODE_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function uqcDelete(data) {
  return async (dispatch) => {
    dispatch({ type: UQC_CODE_DELETE_REQUEST });
    try {
      var response = await axiosInstance.post(`delete_uqc`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: UQC_CODE_DELETE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: UQC_CODE_DELETE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: UQC_CODE_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function uqcUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: UQC_CODE_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`update_uqc`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: UQC_CODE_UPDATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: UQC_CODE_UPDATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: UQC_CODE_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function uqcSingleData(data) {
  return async (dispatch) => {
    dispatch({ type: UQC_CODE_SINGLE_DATA_REQUEST });
    try {
      var response = await axiosInstance.post(`single_uqc_record`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: UQC_CODE_SINGLE_DATA_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: UQC_CODE_SINGLE_DATA_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: UQC_CODE_SINGLE_DATA_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockCategoryCreate(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_CATEGORY_CREATE_REQUEST });
    try {
      var response = await axiosInstance.post(`category_create`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_CATEGORY_CREATE_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_CATEGORY_CREATE_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_CATEGORY_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockCategoryNameValidate(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_CATEGORY_NAME_VALIDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`check_duplicate_category`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_CATEGORY_NAME_VALIDATE_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_CATEGORY_NAME_VALIDATE_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_CATEGORY_NAME_VALIDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockCategoryUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_CATEGORY_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`update_category`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_CATEGORY_UPDATE_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_CATEGORY_UPDATE_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_CATEGORY_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockCategoryList(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_CATEGORY_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`category_List`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_CATEGORY_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_CATEGORY_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_CATEGORY_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockCategoryPrimaryList(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_CATEGORY_UNDER_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`allCategory_List`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_CATEGORY_UNDER_LIST_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_CATEGORY_UNDER_LIST_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_CATEGORY_UNDER_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}

export function stockCategoryDelete(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_CATEGORY_DELETE_REQUEST });
    try {
      var response = await axiosInstance.post(`delete_category`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_CATEGORY_DELETE_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_CATEGORY_DELETE_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_CATEGORY_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockCategorySingleData(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_CATEGORY_SINGLE_REQUEST });
    try {
      var response = await axiosInstance.post(`single_category_record`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_CATEGORY_SINGLE_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_CATEGORY_SINGLE_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_CATEGORY_SINGLE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockGroupCreate(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_GROUP_CREATE_REQUEST });
    try {
      var response = await axiosInstance.post(`create-stock-group`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_GROUP_CREATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_GROUP_CREATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_GROUP_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockGroupUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_GROUP_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`update-stock-group`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_GROUP_UPDATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_GROUP_UPDATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_GROUP_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockGroupPrimaryList(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_GROUP_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`primary-stock-group`, data);
      var responseJson = response.data;
      //console.log("stock primary data----", responseJson);
      if (responseJson?.status) {
        dispatch({ type: STOCK_GROUP_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_GROUP_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_GROUP_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockGroupList(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_GROUP_UNDER_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`stock-group`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_GROUP_UNDER_LIST_SUCCESS,
          payload: responseJson,
        });
        //return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_GROUP_UNDER_LIST_FAILURE,
          payload: responseJson,
        });
        //return Promise.reject(responseJson);
      }
      return responseJson;
    } catch (error) {
      dispatch({ type: STOCK_GROUP_UNDER_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockGroupDelete(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_GROUP_DELETE_REQUEST });
    try {
      var response = await axiosInstance.post(`delete_stock_group`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_GROUP_DELETE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_GROUP_DELETE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_GROUP_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockGroupSingleData(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_GROUP_SINGLE_DATA_REQUEST });
    try {
      var response = await axiosInstance.post(`stock-group-details`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_GROUP_SINGLE_DATA_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_GROUP_SINGLE_DATA_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_GROUP_SINGLE_DATA_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockCompanyCreate(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_COMPANY_CREATE_REQUEST });
    try {
      var response = await axiosInstance.post(`create-stock-company`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_COMPANY_CREATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_COMPANY_CREATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_COMPANY_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockCompanyUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_COMPANY_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`update-stock-company`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_COMPANY_UPDATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_COMPANY_UPDATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_COMPANY_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockCompanyList(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_COMPANY_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`stock-company`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_COMPANY_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_COMPANY_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_COMPANY_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockCompanyDelete(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_COMPANY_DELETE_REQUEST });
    try {
      var response = await axiosInstance.post(`delete_stock_company`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_COMPANY_DELETE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_COMPANY_DELETE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_COMPANY_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockCompanySingleData(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_COMPANY_SINGLE_DATA_REQUEST });
    try {
      var response = await axiosInstance.post(`stock-company-details`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_COMPANY_SINGLE_DATA_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_COMPANY_SINGLE_DATA_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_COMPANY_SINGLE_DATA_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}

export function stockItemCreate(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_ITEM_CREATE_REQUEST });
    try {
      // Log FormData contents
      // if (data instanceof FormData) {
      //     console.log("Stock Item create data:");
      //     for (let pair of data.entries()) {
      //         console.log(pair[0] + ': ' + pair[1]);
      //     }
      // }

      var response = await axiosInstance.post(`create-stock-item`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_ITEM_CREATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_ITEM_CREATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_ITEM_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockItemUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_ITEM_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`update-stock-item`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_ITEM_UPDATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_ITEM_UPDATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_ITEM_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockItemList(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_ITEM_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`stock-item`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_ITEM_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_ITEM_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_ITEM_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockItemListToDropdown(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_ITEM_LIST_TO_DROPDOWN_REQUEST });
    try {
      var response = await axiosInstance.post(`stock-item-qty`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_ITEM_LIST_TO_DROPDOWN_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_ITEM_LIST_TO_DROPDOWN_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_ITEM_LIST_TO_DROPDOWN_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockItemDelete(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_ITEM_DELETE_REQUEST });
    try {
      var response = await axiosInstance.post(`delete_stock_item`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_ITEM_DELETE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_ITEM_DELETE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_ITEM_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockItemSingleData(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_ITEM_SINGLE_DATA_REQUEST });
    try {
      var response = await axiosInstance.post(`stock-item-details`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_ITEM_SINGLE_DATA_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_ITEM_SINGLE_DATA_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_ITEM_SINGLE_DATA_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function voucherTypeCreate(data) {
  return async (dispatch) => {
    dispatch({ type: VOUCHER_TYPE_CREATE_REQUEST });
    try {
      var response = await axiosInstance.post(`create-voucher-type`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: VOUCHER_TYPE_CREATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: VOUCHER_TYPE_CREATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: VOUCHER_TYPE_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function voucherTypeUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: VOUCHER_TYPE_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`update-voucher-type`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: VOUCHER_TYPE_UPDATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: VOUCHER_TYPE_UPDATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: VOUCHER_TYPE_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function voucherTypeList(data) {
  return async (dispatch) => {
    dispatch({ type: VOUCHER_TYPE_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`voucher-type-list`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: VOUCHER_TYPE_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: VOUCHER_TYPE_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      console.log("voucher type list --", error);
      dispatch({ type: VOUCHER_TYPE_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function voucherTypeDefaultList(data) {
  return async (dispatch) => {
    dispatch({ type: VOUCHER_TYPE_DEFAULT_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(
        `primary-voucher-type-list`,
        data,
      );
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: VOUCHER_TYPE_DEFAULT_LIST_SUCCSESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: VOUCHER_TYPE_DEFAULT_LIST_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      console.log("voucher type list --", error);
      dispatch({ type: VOUCHER_TYPE_DEFAULT_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function voucherTypeDelete(data) {
  return async (dispatch) => {
    dispatch({ type: VOUCHER_TYPE_DELETE_REQUEST });
    try {
      var response = await axiosInstance.post(`delete_voucher_type`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: VOUCHER_TYPE_DELETE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: VOUCHER_TYPE_DELETE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: VOUCHER_TYPE_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function voucherTypeSingleData(data) {
  return async (dispatch) => {
    dispatch({ type: VOUCHER_TYPE_SINGLE_DATA_REQUEST });
    try {
      var response = await axiosInstance.post(`voucher-type-details`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: VOUCHER_TYPE_SINGLE_DATA_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: VOUCHER_TYPE_SINGLE_DATA_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: VOUCHER_TYPE_SINGLE_DATA_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// voucher type name check ----------------------------
export function voucherTypeNameCheck(data) {
  return async (dispatch) => {
    dispatch({ type: VOUCHER_TYPE_NAME_CHECK_REQUEST });
    try {
      var response = await axiosInstance.post(`check-voucher-type`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: VOUCHER_TYPE_NAME_CHECK_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: VOUCHER_TYPE_NAME_CHECK_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: VOUCHER_TYPE_NAME_CHECK_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// number series create =======================================
export function numberSeriesCreate(data) {
  return async (dispatch) => {
    dispatch({ type: NUMBER_SERIES_CREATE_REQUEST });
    try {
      var response = await axiosInstance.post(
        `create-voucher-number-series`,
        data,
      );
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: NUMBER_SERIES_CREATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: NUMBER_SERIES_CREATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: NUMBER_SERIES_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// voucher type number list ============================================
export function numberSeriesList(data) {
  return async (dispatch) => {
    dispatch({ type: NUMBER_SERIES_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(
        `voucher-number-series-list`,
        data,
      );
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: NUMBER_SERIES_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: NUMBER_SERIES_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: NUMBER_SERIES_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function numberSeriesSingleData(data) {
  return async (dispatch) => {
    dispatch({ type: NUMBER_SERIES_SINGLE_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(
        `single_voucher_number_series`,
        data,
      );
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: NUMBER_SERIES_SINGLE_LIST_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: NUMBER_SERIES_SINGLE_LIST_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: NUMBER_SERIES_SINGLE_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function numberSeriesUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: NUMBER_SERIES_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(
        `update_voucher_number_series`,
        data,
      );
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: NUMBER_SERIES_UPDATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: NUMBER_SERIES_UPDATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: NUMBER_SERIES_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// voucher type number list ============================================
export function godownCreate(data) {
  return async (dispatch) => {
    dispatch({ type: GODOWN_CREATE_REQUEST });
    try {
      var response = await axiosInstance.post(`godown_create`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: GODOWN_CREATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GODOWN_CREATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GODOWN_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// voucher type number list ============================================
export function godownUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: GODOWN_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`update_godown`, data);
      var responseJson = response.data;
      console.log(responseJson);
      if (responseJson?.status) {
        dispatch({ type: GODOWN_UPDATE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GODOWN_UPDATE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GODOWN_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// voucher type number list ============================================
export function godownList(data) {
  return async (dispatch) => {
    dispatch({ type: GODOWN_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`godown_List`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: GODOWN_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GODOWN_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GODOWN_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// voucher type number list ============================================
export function godownDelete(data) {
  return async (dispatch) => {
    dispatch({ type: GODOWN_DELETE_REQUEST });
    try {
      var response = await axiosInstance.post(`delete_godown`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: GODOWN_DELETE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GODOWN_DELETE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GODOWN_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// voucher type number list ============================================
export function godownSingleData(data) {
  return async (dispatch) => {
    dispatch({ type: GODOWN_SINGLE_DATA_REQUEST });
    try {
      var response = await axiosInstance.post(`single_godown_record`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: GODOWN_SINGLE_DATA_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GODOWN_SINGLE_DATA_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GODOWN_SINGLE_DATA_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function godownPrimaryList(data) {
  return async (dispatch) => {
    dispatch({ type: GODOWN_PRIMARY_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`primary_godown_list`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: GODOWN_PRIMARY_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GODOWN_PRIMARY_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GODOWN_PRIMARY_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// CONTRA LEDGER LISTING IN VOUCHER ENTRY==================================
// export function contraLedgerListing(data) {
//   return async (dispatch) => {
//     dispatch({ type: CONTRA_LEDGER_LIST_REQUEST });
//     try {
//       var response = await axiosInstance.post(`ledger_by_groups`, data);
//       var responseJson = response.data;
//       if (responseJson?.status) {
//         dispatch({ type: CONTRA_LEDGER_LIST_SUCCESS, payload: responseJson });
//         return Promise.resolve(responseJson);
//       } else {
//         dispatch({ type: CONTRA_LEDGER_LIST_FAILURE, payload: responseJson });
//         return Promise.reject(responseJson);
//       }
//     } catch (error) {
//       dispatch({ type: CONTRA_LEDGER_LIST_FAILURE, payload: error });
//       return Promise.reject(error);
//     }
//   };
// }
export const contraLedgerListing = (data) =>
  createAsyncThunk({
    endpoint: "ledger_by_groups",
    method: "post",
    data,
    requestType: CONTRA_LEDGER_LIST_REQUEST,
    successType: CONTRA_LEDGER_LIST_SUCCESS,
    failureType: CONTRA_LEDGER_LIST_FAILURE,
    successMessage: "Contra ledger listing successful!",
    silent: true,
  });
// SERIAL NUMBER IN VOUCHER ENTRY==================================
export function serialNumberList(data) {
  return async (dispatch) => {
    dispatch({ type: SERIAL_NUMBER_REQUEST });
    try {
      var response = await axiosInstance.post(
        `voucher-type-number-series`,
        data,
      );
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: SERIAL_NUMBER_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: SERIAL_NUMBER_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: SERIAL_NUMBER_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// CONTRA VOUCHER ENTRY CREATE==================================
export function contraVoucherCreate(data) {
  return async (dispatch) => {
    dispatch({ type: CONTRA_VOUCHER_ENTRY_CREATE_REQUEST });
    try {
      var response = await axiosInstance.post(`create-voucher-entry`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: CONTRA_VOUCHER_ENTRY_CREATE_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: CONTRA_VOUCHER_ENTRY_CREATE_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: CONTRA_VOUCHER_ENTRY_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function contraVoucherList(data) {
  return async (dispatch) => {
    dispatch({ type: CONTRA_VOUCHER_ENTRY_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`getVoucherEntry`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: CONTRA_VOUCHER_ENTRY_LIST_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: CONTRA_VOUCHER_ENTRY_LIST_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: CONTRA_VOUCHER_ENTRY_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function contraVoucherSingle(data) {
  return async (dispatch) => {
    dispatch({ type: CONTRA_VOUCHER_ENTRY_SINGLE_REQUEST });
    try {
      var response = await axiosInstance.post(`single-voucher-entries`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: CONTRA_VOUCHER_ENTRY_SINGLE_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: CONTRA_VOUCHER_ENTRY_SINGLE_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: CONTRA_VOUCHER_ENTRY_SINGLE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function contraVoucherUpdate(data) {
  return async (dispatch) => {
    dispatch({ type: CONTRA_VOUCHER_ENTRY_UPDATE_REQUEST });
    try {
      var response = await axiosInstance.post(`update-voucher`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: CONTRA_VOUCHER_ENTRY_UPDATE_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: CONTRA_VOUCHER_ENTRY_UPDATE_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: CONTRA_VOUCHER_ENTRY_UPDATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function voucherEntryDelete(data) {
  return async (dispatch) => {
    dispatch({ type: VOUCHER_ENTRY_DELETE_REQUEST });
    try {
      var response = await axiosInstance.post(`delete_voucher_entry`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: VOUCHER_ENTRY_DELETE_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: VOUCHER_ENTRY_DELETE_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: VOUCHER_ENTRY_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export const storeVoucherEntryData = (data) => {
  return {
    type: VOUCHER_TYPE_SAVE,
    payload: data,
  };
};
export function ledgerBookList(data) {
  return async (dispatch) => {
    dispatch({ type: LEDGER_BOOK_REQUEST });
    try {
      var response = await axiosInstance.post(`ledger_by_company`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: LEDGER_BOOK_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: LEDGER_BOOK_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: LEDGER_BOOK_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function ledgerPostingList(data) {
  return async (dispatch) => {
    dispatch({ type: LEDGER_POSTING_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`ledger_posting_details`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: LEDGER_POSTING_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: LEDGER_POSTING_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: LEDGER_POSTING_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// CURRENT PERIOD REDUX ====================
export const currentDateRedux = (data) => {
  return {
    type: CURRENT_DATE_SAVE,
    payload: data,
  };
};

// Auto update current date ====================
export const updateCurrentDateAuto = () => {
  return {
    type: UPDATE_CURRENT_DATE_AUTO,
  };
};
// CURRENT PERIOD REDUX ====================
export const conditionalApi = (data) => {
  return {
    type: FILTER_API_CALL,
    payload: data,
  };
};

// CURRENT PERIOD REDUX====================
export const currentPeriodRedux = (data) => {
  return {
    type: CURRENT_PERIOD_SAVE,
    payload: data,
  };
};
//-----------------
export function stockSummaryList(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_SUMMARY_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(`stock-summary`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: STOCK_SUMMARY_LIST_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: STOCK_SUMMARY_LIST_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_SUMMARY_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function stockSummaryItemVoucherList(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_SUMMARY_ITEM_VOUCHER_REQUEST });
    try {
      var response = await axiosInstance.post(`stock-item-voucher`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_SUMMARY_ITEM_VOUCHER_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_SUMMARY_ITEM_VOUCHER_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: STOCK_SUMMARY_ITEM_VOUCHER_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
//-----------------
export function stockSummaryGodownFilterList(data) {
  return async (dispatch) => {
    dispatch({ type: STOCK_SUMMARY_GODOWN_FILTER_LIST_REQUEST });
    try {
      var response = await axiosInstance.post(
        `filter-stock-item-bylocation`,
        data,
      );
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({
          type: STOCK_SUMMARY_GODOWN_FILTER_LIST_SUCCESS,
          payload: responseJson,
        });
        return Promise.resolve(responseJson);
      } else {
        dispatch({
          type: STOCK_SUMMARY_GODOWN_FILTER_LIST_FAILURE,
          payload: responseJson,
        });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({
        type: STOCK_SUMMARY_GODOWN_FILTER_LIST_FAILURE,
        payload: error,
      });
      return Promise.reject(error);
    }
  };
}
/*export function maxDateOfEntry(data) {
    return async (dispatch) => {
        dispatch({ type: MAX_DATE_OF_ENTRY_REQUEST });
        try {
            var response = await axiosInstance.post(`last-voucher-entry`, data);
            var responseJson = response.data;
            if (responseJson?.status) {
                dispatch({ type: MAX_DATE_OF_ENTRY_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: MAX_DATE_OF_ENTRY_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: MAX_DATE_OF_ENTRY_FAILURE, payload: error });
            return Promise.reject(error)
        }
    }
}*/
export function maxDateOfEntry(data) {
  return async (dispatch) => {
    dispatch({ type: MAX_DATE_OF_ENTRY_REQUEST });

    try {
      const response = await axiosInstance.post(`last-voucher-entry`, data);
      const responseJson = response.data;

      if (responseJson?.status) {
        dispatch({ type: MAX_DATE_OF_ENTRY_SUCCESS, payload: responseJson });
      } else {
        dispatch({ type: MAX_DATE_OF_ENTRY_FAILURE, payload: responseJson });
      }

      // 👇 Always resolve, no reject here
      return responseJson;
    } catch (error) {
      dispatch({ type: MAX_DATE_OF_ENTRY_FAILURE, payload: error });

      // You can normalise the error object a bit:
      return {
        status: false,
        message: error?.message || "Something went wrong",
        error,
      };
    }
  };
}
// Filter voucher type data
export const filterVoucherTypeData = (data) => {
  return {
    type: FILTER_VOUCHER_TYPE_DATA,
    payload: data,
  };
};

export function profitAndLoss(data) {
  return async (dispatch) => {
    dispatch({ type: PROFIT_AND_LOSS_REQUEST });
    try {
      var response = await axiosInstance.post(`profit-loss`, data);
      var responseJson = response.data;
      if (responseJson?.status) {
        dispatch({ type: PROFIT_AND_LOSS_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: PROFIT_AND_LOSS_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: PROFIT_AND_LOSS_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
export function groupSummary(data) {
  return async (dispatch) => {
    dispatch({ type: GROUP_SUMMARY_REQUEST });
    try {
      var response = await axiosInstance.post(`group-summary`, data);
      var responseJson = response;
      if (responseJson?.status) {
        dispatch({ type: GROUP_SUMMARY_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: GROUP_SUMMARY_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: GROUP_SUMMARY_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}
// Balance sheet
export function balanceSheet(data) {
  return async (dispatch) => {
    dispatch({ type: BALANCE_SHEET_REQUEST });
    try {
      var response = await axiosInstance.post(`balance-sheet`, data);
      var responseJson = response;
      if (responseJson?.status) {
        dispatch({ type: BALANCE_SHEET_SUCCESS, payload: responseJson });
        return Promise.resolve(responseJson);
      } else {
        dispatch({ type: BALANCE_SHEET_FAILURE, payload: responseJson });
        return Promise.reject(responseJson);
      }
    } catch (error) {
      dispatch({ type: BALANCE_SHEET_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}

export function openModal(modalId) {
  return (dispatch) => {
    dispatch({ type: OPEN_MODAL, payload: modalId });
  };
}
export function closeModal(modalId) {
  return (dispatch) => {
    dispatch({ type: CLOSE_MODAL, payload: modalId });
    restoreAltCFocusReturn(modalId);
  };
}
export function closeAllModals() {
  return (dispatch) => {
    dispatch({ type: CLOSE_ALL_MODALS });
  };
}

// For page history management
export function savePageHistory(path, state) {
  return {
    type: SAVE_PAGE_HISTORY,
    payload: { path, state },
  };
}

export function savePageFocus(path, focusId) {
  return {
    type: SET_PAGE_FOCUS,
    payload: { path, focusId },
  };
}

export function saveStockSummaryState(data) {
  return {
    type: SAVE_STOCK_SUMMARY_STATE,
    payload: data,
  };
}

export function saveChartOfAccountsState(data) {
  return {
    type: SAVE_CHART_OF_ACCOUNTS_STATE,
    payload: data,
  };
}

export function saveDaybookState(data) {
  return {
    type: SAVE_DAYBOOK_STATE,
    payload: data,
  };
}

// ==================== BRANCH ACTIONS ====================
export function branchList(data) {
  return async (dispatch) => {
    dispatch({ type: BRANCH_LIST_REQUEST });
    try {
      const response = await axiosInstance.post('branch_list', data);
      const res = response.data;
      if (res?.status) {
        dispatch({ type: BRANCH_LIST_SUCCESS, payload: res });
        return Promise.resolve(res);
      } else {
        dispatch({ type: BRANCH_LIST_FAILURE, payload: res });
        return Promise.reject(res);
      }
    } catch (error) {
      dispatch({ type: BRANCH_LIST_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}

export function branchCreate(data) {
  return async (dispatch) => {
    dispatch({ type: BRANCH_CREATE_REQUEST });
    try {
      const response = await axiosInstance.post('branch_create', data);
      const res = response.data;
      if (res?.status) {
        dispatch({ type: BRANCH_CREATE_SUCCESS, payload: res });
        return Promise.resolve(res);
      } else {
        dispatch({ type: BRANCH_CREATE_FAILURE, payload: res });
        return Promise.reject(res);
      }
    } catch (error) {
      dispatch({ type: BRANCH_CREATE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}

export function branchDelete(data) {
  return async (dispatch) => {
    dispatch({ type: BRANCH_DELETE_REQUEST });
    try {
      const response = await axiosInstance.post('branch_delete', data);
      const res = response.data;
      if (res?.status) {
        dispatch({ type: BRANCH_DELETE_SUCCESS, payload: res });
        return Promise.resolve(res);
      } else {
        dispatch({ type: BRANCH_DELETE_FAILURE, payload: res });
        return Promise.reject(res);
      }
    } catch (error) {
      dispatch({ type: BRANCH_DELETE_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}

export function branchLogin(data) {
  return async (dispatch) => {
    dispatch({ type: BRANCH_LOGIN_REQUEST });
    try {
      const response = await axiosInstance.post('branch_login', data);
      const res = response.data;
      if (res?.status) {
        dispatch({ type: SIGN_IN_SUCCESS, payload: res }); // reuse auth reducer
        return Promise.resolve(res);
      } else {
        dispatch({ type: BRANCH_LOGIN_FAILURE, payload: res });
        return Promise.reject(res);
      }
    } catch (error) {
      dispatch({ type: BRANCH_LOGIN_FAILURE, payload: error });
      return Promise.reject(error);
    }
  };
}

// ============================================================
// MAIL CONFIGURATION ACTIONS
// ============================================================

export const mailConfigSave = (data) =>
  createAsyncThunk({
    endpoint: "mail-config-save",
    method: "post",
    data,
    requestType: "MAIL_CONFIG_SAVE_REQUEST",
    successType: "MAIL_CONFIG_SAVE_SUCCESS",
    failureType: "MAIL_CONFIG_SAVE_FAILURE",
    silent: true,
  });

export const mailConfigGet = (data) =>
  createAsyncThunk({
    endpoint: "mail-config-get",
    method: "post",
    data,
    requestType: "MAIL_CONFIG_GET_REQUEST",
    successType: "MAIL_CONFIG_GET_SUCCESS",
    failureType: "MAIL_CONFIG_GET_FAILURE",
    silent: true,
  });

export const mailConfigTest = (data) =>
  createAsyncThunk({
    endpoint: "mail-config-test",
    method: "post",
    data,
    requestType: "MAIL_CONFIG_TEST_REQUEST",
    successType: "MAIL_CONFIG_TEST_SUCCESS",
    failureType: "MAIL_CONFIG_TEST_FAILURE",
    silent: true,
  });

export const forgotPasswordSendOtp = (data) =>
  createAsyncThunk({
    endpoint: "forgot-password-send-otp",
    method: "post",
    data,
    requestType: "FORGOT_PASSWORD_SEND_OTP_REQUEST",
    successType: "FORGOT_PASSWORD_SEND_OTP_SUCCESS",
    failureType: "FORGOT_PASSWORD_SEND_OTP_FAILURE",
    silent: true,
  });

export const forgotPasswordReset = (data) =>
  createAsyncThunk({
    endpoint: "forgot-password-reset",
    method: "post",
    data,
    requestType: "FORGOT_PASSWORD_RESET_REQUEST",
    successType: "FORGOT_PASSWORD_RESET_SUCCESS",
    failureType: "FORGOT_PASSWORD_RESET_FAILURE",
    silent: true,
  });

export const changeUsername = (data) =>
  createAsyncThunk({
    endpoint: "change-username",
    method: "post",
    data,
    requestType: "CHANGE_USERNAME_REQUEST",
    successType: "CHANGE_USERNAME_SUCCESS",
    failureType: "CHANGE_USERNAME_FAILURE",
    silent: true,
  });

export const changePassword = (data) =>
  createAsyncThunk({
    endpoint: "change-password",
    method: "post",
    data,
    requestType: "CHANGE_PASSWORD_REQUEST",
    successType: "CHANGE_PASSWORD_SUCCESS",
    failureType: "CHANGE_PASSWORD_FAILURE",
    silent: true,
  });

